import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmContextMenuItemModule} from '../sm-context-menu-item/sm-context-menu-item.module';
import {SmContextMenuComponent} from './sm-context-menu.component';
import {SmPlainTextTooltipDirective} from '../../directives/sm-plain-text-tooltip.directive';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmContextMenuItemModule,
    SmPlainTextTooltipDirective,
  ],
  declarations: [SmContextMenuComponent],
  exports: [SmContextMenuComponent],
})
export class SmContextMenuModule {}
